import { lazy } from 'react';

const Dashboard = lazy(() => import('./AdminDashboardPage'));

const AdminDashboardConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'admin/dashboard',
      element: <Dashboard />,
    },
  ],
};

export default AdminDashboardConfig;
